<app-navbar></app-navbar>


<div class="affaires">
  <a routerLink="/new-command">
    <button>
      <mat-icon>
        add_box
      </mat-icon>
      Nouvelle Commande
    </button>
  </a>
  <div class="header">
    <div class="spinner-container">
      <mat-progress-spinner
        *ngIf="isLoading"
        mode="indeterminate"
        diameter="30"
        class="spinner">
      </mat-progress-spinner>
      <h2>{{ lotsCount }} lots trouvé(s)</h2>
    </div>
    <div>
      <div class="inputs-contenair">
        <input [(ngModel)]="searchString" (ngModelChange)="updateSearchString($event)" placeholder="Recherche par nom..." />
      </div>
    </div>
  </div>
  <div>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nom du lot</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>

        <ng-container matColumnDef="affairsCount">
          <th mat-header-cell *matHeaderCellDef>Nombre d'affaires</th>
          <td mat-cell *matCellDef="let row">{{ row.affairsCount }}</td>
        </ng-container>

        <ng-container matColumnDef="registerDate">
          <th mat-header-cell *matHeaderCellDef>Date de création</th>
          <td mat-cell *matCellDef="let row">{{ row.registerDate | date }}</td>
        </ng-container>

        <ng-container matColumnDef="nagivate">
          <th mat-header-cell *matHeaderCellDef>Accéder</th>
          <td mat-cell *matCellDef="let row">
            <button>Accéder aux affaires</button>
          </td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="navigateToAffairs(row)"></tr>

      </table>

      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
